import { SingletonRouter } from "next/router";
import { DEFAULT_PAGE } from "../constants";
import { QueryPage } from "../types";

export const getPage = (router?: SingletonRouter<QueryPage>): number =>
  router && router.query && !isNaN(Number(router.query.page))
    ? parseInt(router.query.page as string, 10)
    : DEFAULT_PAGE;
